import React from 'react';
import PaymentComponent from '../../components/dashboard/payment'; 

const PaymentPage = () => {
  return (
    <>
      <PaymentComponent /> 
    </>
  );
};

export default PaymentPage;
